import { Box, Button, Checkbox, FormControlLabel, Stack, TextField, Typography, Autocomplete, MenuItem } from "@mui/material";
import React, { useState, useEffect } from "react";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from "../../../Components/Common Components/CommonComponents";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import Loader from '../../../Components/Loader'
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'
import { DataGrid } from '@mui/x-data-grid'
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { Colors } from "../../../Styles/Colors";
import CommonValidation from "../../../Components/CommonFunctions/CommonValidation";

const CouponMaster = () => {
  const [formState, setFormState] = useState({
    couponId: "",
    couponName: "",
    couponCode: "",
    couponSeriesStart: "",
    couponSeriesEnd: "",
    discountType: "",
    discountValue: "",
    applicableFor: [],
    startDate: "",
    endDate: "",
    patientType: ""
  });
  const [isActive, setIsActive] = useState(true);
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  });
  const [CouponData, setCouponData] = useState([]);
  const [EditID, setEditID] = useState(null);
  const [isDelete, setisDelete] = useState(false);
  const [deletedID, setdeletedID] = useState(null);
  const [delIDs, setdelIDs] = useState([]);
  const [CheckBoxList, setCheckBoxList] = useState([]);
  const [isloader, setisloader] = useState(false);
  const [page, setpage] = useState(0);
  const [pageSize, setpageSize] = useState(10);
  const today = new Date().toISOString().split("T")[0];
  let commonDisable = CheckAccessFunc("front_office", "Settings", "Service Master Configuration", "Coupon Master", "SubTab")?.editAccess

  const DiscountTypes = [
    { label: "Percentage (%)", value: "PERCENTAGE" },
    { label: "Fixed Amount", value: "FIXED" }
  ];

  const ApplicableForList = [
    { label: "IP", value: "IP" },
    { label: "OP", value: "OP" },
    { label: "Lab", value: "LAB" }
  ];

  const PatientTypes = [
    { label: "New Patient", value: "NEW" },
    { label: "Old Patient", value: "OLD" },
    { label: "Review Patient", value: "REVIEW" },
    { label: "Established", value: "ESTABLISHED" }
  ];

  useEffect(() => {
    getCouponMaster();
  }, []);

  const getCouponMaster = () => {
    setisloader(true)
    RestAPIService.getAll(Serviceurls.AYURVEDA_COUPON_MASTER)
      .then((response) => {
        if (response.data.status === 'success') {
          setCouponData(response?.data?.data || [])
        }
        setisloader(false)
      }).catch(e => {
        setisloader(false)
        errorMessage(e?.response?.data?.message || e.message)
      })
  }

  const AddCoupon = () => {
    if (!formState?.couponName) return errorMessage("Please Enter Coupon Name");
    if (!formState?.couponCode) return errorMessage("Please Enter Coupon Code");
    if (!formState?.couponSeriesStart) return errorMessage("Please Enter Coupon Series Start");
    if (!formState?.couponSeriesEnd) return errorMessage("Please Enter Coupon Series End");
    if (!formState?.discountType) return errorMessage("Please Select Discount Type");
    if (!formState?.discountValue) return errorMessage("Please Enter Discount Value");
    if (formState?.applicableFor?.length === 0) return errorMessage("Please Select Applicable For");
    if (!formState?.startDate) return errorMessage("Please Select Start Date");
    if (!formState?.endDate) return errorMessage("Please Select End Date");
    if (!formState?.patientType) return errorMessage("Please Select Patient Type");

    let data = {
      coupon_name: formState?.couponName,
      coupon_code: formState?.couponCode,
      coupon_series_start: formState?.couponSeriesStart,
      coupon_series_end: formState?.couponSeriesEnd,
      discount_type: formState?.discountType,
      discount_value: formState?.discountValue,
      applicable_for: formState?.applicableFor.map(a => a.value),
      start_date: formState?.startDate,
      end_date: formState?.endDate,
      patient_type: formState?.patientType,
      is_active: isActive
    }

    setisloader(true)
    let apiCall;
    if (EditID) {
      apiCall = RestAPIService.update(EditID, data, Serviceurls.AYURVEDA_COUPON_MASTER);
    } else {
      apiCall = RestAPIService.create(data, Serviceurls.AYURVEDA_COUPON_MASTER);
    }
    apiCall
      .then((response) => {
        if (response.data.status === 'success') {
          successMessage(response.data.message)
          clearForm()
          getCouponMaster()
        }
        setisloader(false)
      }).catch(e => {
        setisloader(false)
        errorMessage(e?.response?.data?.message || e.message)
      })
  }

  const clearForm = () => {
    setFormState({
      couponId: "",
      couponName: "",
      couponCode: "",
      couponSeriesStart: "",
      couponSeriesEnd: "",
      discountType: "",
      discountValue: "",
      applicableFor: [],
      startDate: "",
      endDate: "",
      patientType: ""
    });
    setIsActive(true)
    setEditID(null)
  }

  const deleteCoupon = () => {
    let ID = deletedID ? [deletedID] : (delIDs || [])
    RestAPIService.delete(Serviceurls.AYURVEDA_COUPON_MASTER + `?ids=${ID}`)
      .then((response) => {
        if (response.data.status === 'success') {
          successMessage(response.data.message)
          getCouponMaster()
          setdelIDs([]);
          setCheckBoxList([]);
          setdeletedID(null);
          setisDelete(false)
        }
      }).catch(e => {
        errorMessage(e?.response?.data?.message || e.message)
      })
  }

  const errorMessage = (msg) => {
    setMessage({ ...message, isErrorMsg: true, isErrorMsgText: msg })
  }
  const successMessage = (msg) => {
    setMessage({ ...message, successMsg: true, successMsgText: msg })
  }
  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  const tableView = () => {
    const grpDelete = () => setisDelete(true)
    const gridToolBar = () => (
      <Box>
        <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} />
      </Box>
    )

    const handleTableCheckbox = (id) => {
      let selectedIDs = new Set(id);
      setCheckBoxList(id)
      let selectedRows = CouponData.filter((row) => selectedIDs.has(row.sno));
      let FinalData = []
      selectedRows.forEach((item) => {
        FinalData.push(item.id)
      })
      setdelIDs(FinalData)
    }

    CouponData?.forEach((element, index) => element.sno = index + 1)

    const columns = [
      { field: 'coupon_code', headerName: 'Coupon Code', flex: 0.15 },
      { field: 'coupon_name', headerName: 'Coupon Name', flex: 0.3 },
      { field: 'coupon_series_start', headerName: 'Coupon Start', flex: 0.1 },
      { field: 'coupon_series_end', headerName: 'Coupon End', flex: 0.1 },
      { field: 'applicable_for_display', headerName: 'Applicable For', flex: 0.25 },
      { field: 'discount_value', headerName: 'Discount Value', flex: 0.15 },
      { field: 'start_date', headerName: 'Start Date', flex: 0.15 },
      { field: 'end_date', headerName: 'End Date', flex: 0.15 },
      { field: 'patient_type', headerName: 'Patient Type', flex: 0.2 },
      {
        field: 'is_active', headerName: 'Status', flex: 0.1,
        renderCell: (params) => (<Box>{params?.row?.is_active ? "Active" : "Inactive"}</Box>)
      },
      ...(commonDisable ? [{
        field: 'action', headerName: 'Action', flex: 0.1, headerAlign: "center", align: "center",
        renderCell: (params) => (
          <Stack direction="row" alignItems="center" spacing={4}>
            <CommonEditButton size="1.5vw" onClick={() => {
              setFormState({
                couponId: params.row.coupon_id,
                couponName: params.row.coupon_name,
                couponCode: params.row.coupon_code,
                couponSeriesStart: params.row.coupon_series_start,
                couponSeriesEnd: params.row.coupon_series_end,
                discountType: params.row.discount_type,
                discountValue: params.row.discount_value,
                applicableFor: ApplicableForList.filter(a => params.row.applicable_for_display?.includes(a.value)),
                startDate: params.row.start_date,
                endDate: params.row.end_date,
                patientType: params.row.patient_type
              });
              setEditID(params.row.id);
              setIsActive(params.row.is_active);
            }} />
          </Stack>)
      }] : [])
    ]

    return (
      <Box sx={{ height: '60vh' }}>
        <DataGrid
          checkboxSelection={commonDisable ? true : false}
          selectionModel={CheckBoxList}
          onRowSelectionModelChange={(id) => handleTableCheckbox(id)}
          rows={CouponData}
          columns={columns}
          getRowId={(row) => row['sno']}
          components={{ Toolbar: gridToolBar }}
          pageSizeOptions={[10, 20, 30]}
          pagination
          paginationMode="client"
          paginationModel={{
            page: page,
            pageSize: pageSize
          }}
          onPaginationModelChange={(model) => {
            setpage(model.page)
            setpageSize(model.pageSize)
          }}
          headerHeight={40}
          density='compact'
          disableRowSelectionOnClick
          loading={isloader}
          getRowClassName={(params) => params.row.is_active === false ? 'gray-row' : ''}
          sx={{
            "& .gray-row .MuiDataGrid-cell": {
              backgroundColor: "#e8e7e7 !important",
              color: "black !important",
            },
            "& .gray-row .MuiDataGrid-cell[data-field='action'], & .gray-row:has(.MuiDataGrid-cell--checkbox)": {
              backgroundColor: "white !important",
              color: "black !important",
            },
            "& .gray-row .MuiDataGrid-cell:nth-child(1)": {
              backgroundColor: "white !important",
            }
          }}
        />
      </Box>
    )
  }

  return (
    <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
      <Box sx={{ height: '21vh', width: '93vw', backgroundColor: "white", padding: "0.5vw" }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: "wrap" }}>
          <TextField size="small" name="couponId" value={formState?.couponId} disabled sx={{ width: "15vw", marginRight: "1vw" }} label="Coupon ID" />
          <TextField size="small" name="couponName" inputProps={{ maxlength: 50 }} value={formState?.couponName} sx={{ width: "20vw", marginRight: "1vw" }} label="Coupon Name *"
            onChange={(e) => setFormState({ ...formState, couponName: e.target.value })} />
          <TextField size="small" name="couponCode" inputProps={{ maxlength: 20 }} value={formState?.couponCode} sx={{ width: "15vw", marginRight: "1vw" }} label="Coupon Code *"
            onChange={(e) => setFormState({ ...formState, couponCode: e.target.value })} />
          <TextField size="small" name="couponSeriesStart" inputProps={{ maxlength: 10 }} value={formState?.couponSeriesStart} sx={{ width: "10vw", marginRight: "1vw" }} label="Coupon Series Start *"
            onChange={(e) => {
              if (CommonValidation.numberOnly(e.target.value) || e.target.value == "") {
                setFormState({ ...formState, couponSeriesStart: e.target.value })
              }
            }}
          />
          <TextField size="small" name="couponSeriesEnd" inputProps={{ maxlength: 10 }} value={formState?.couponSeriesEnd} sx={{ width: "10vw", marginRight: "1vw" }} label="Coupon Series End *"
            onChange={(e) => {
              if (CommonValidation.numberOnly(e.target.value) || e.target.value == "") {
                setFormState({ ...formState, couponSeriesEnd: e.target.value })
              }
            }} />
          <TextField
            select
            size="small"
            sx={{ width: "15vw", marginRight: "1vw" }}
            label="Discount Type *"
            value={formState?.discountType}
            onChange={(e) =>
              setFormState({
                ...formState,
                discountType: e.target.value, discountValue: ""
              })
            }
          >
            {DiscountTypes.map((item, idx) => (
              <MenuItem key={idx} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField size="small" name="discountValue" value={formState?.discountValue} sx={{ marginTop: "1vw", width: "10vw", marginRight: "1vw" }} label="Discount Value *"
            onChange={(e) => {
              let val = e.target.value
              if (CommonValidation.DecimalNumberTwo(val)) {
                setFormState({ ...formState, discountValue: val })
              } <TextField
                size="small"
                name="discountValue"
                value={formState?.discountValue}
                sx={{ marginTop: "1vw", width: "10vw", marginRight: "1vw" }}
                label="Discount Value *"
                inputProps={{
                  maxLength:
                    formState?.discountType === "FIXED" ? 5 : 5 // safe cap
                }}
                onChange={(e) => {
                  const val = e.target.value;

                  // allow decimals up to 2 places
                  // if (!CommonValidation.DecimalNumberTwo(val)) return;

                  // Percentage: 0–100 only
                  if (formState?.discountType === "PERCENTAGE") {
                    if (Number(val) > 100) return;
                  }

                  // Fixed amount: max 5 digits (handled by maxLength too)
                  if (formState?.discountType === "FIXED") {
                    if (val.replace(".", "").length > 5) return;
                  }

                  setFormState({ ...formState, discountValue: val });
                }}
              />
            }} />
          <Autocomplete multiple size="small" options={ApplicableForList} getOptionLabel={(o) => o.label} value={formState?.applicableFor}
            onChange={(e, val) => setFormState({ ...formState, applicableFor: val })}
            sx={{ marginTop: "1vw", width: "20vw", marginRight: "1vw" }} renderInput={(params) => <TextField {...params} label="Applicable For *" />} />
          <TextField type="date" size="small" name="startDate" value={formState?.startDate} sx={{ marginTop: "1vw", width: "15vw", marginRight: "1vw" }} label="Start Date *"
            InputLabelProps={{ shrink: true }} inputProps={{ min: today }} onChange={(e) => setFormState({ ...formState, startDate: e.target.value, endDate: "" })} />
          <TextField type="date" size="small" name="endDate" value={formState?.endDate} sx={{ marginTop: "1vw", width: "15vw", marginRight: "1vw" }} label="End Date *"
            InputLabelProps={{ shrink: true }} inputProps={{ min: formState?.startDate || undefined, }} onChange={(e) => setFormState({ ...formState, endDate: e.target.value })} />
          <TextField select size="small" sx={{ marginTop: "1vw", width: "20vw", marginRight: "1vw" }} label="Patient Type *"
            value={formState?.patientType} onChange={(e) => setFormState({ ...formState, patientType: e.target.value })}>
            {PatientTypes.map((item, idx) => <MenuItem key={idx} value={item.value}>{item.label}</MenuItem>)}
          </TextField>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginTop: "0.5vw" }}>
          <Box><FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => setIsActive(e.target.checked)} size="small" />} label="Active" /></Box>
          <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
            <Button size="small" variant="outlined" sx={{ textTransform: 'capitalize', width: '7vw', marginRight: "0.5vw" }} onClick={clearForm}>Clear</Button>
            <Button size="small" variant="contained" sx={{ textTransform: 'capitalize', width: '7vw' }} onClick={AddCoupon}>{EditID ? 'Update' : 'Save'}</Button>
          </Box>
        </Box>
      </Box>
      <Box sx={{ height: '60vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white' }}>{tableView()}</Box>

      {message.isErrorMsg && <ToastMsg severity="error" msg={message.isErrorMsgText} msgPop={msgClose} />}
      {message.successMsg && <ToastMsg severity="success" msg={message.successMsgText} msgPop={msgClose} />}
      {isDelete && <DeletePopup DeletTitle="Are you sure you want to delete this coupon?" DeleteNotify="This action cannot be undone."
        deleteAlertPopupClose={() => setisDelete(false)} removeData={deleteCoupon} ButtonText="Yes" />}
      <Loader loaderOpen={isloader} />
    </Box>
  )
}

export default CouponMaster;
